var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58234 10.9782C5.47151 10.9782 5.36068 10.9373 5.27318 10.8498L1.73234 7.30899C1.56318 7.13982 1.56318 6.85982 1.73234 6.69066L5.27318 3.14982C5.44234 2.98066 5.72234 2.98066 5.89151 3.14982C6.06068 3.31899 6.06068 3.59899 5.89151 3.76816L2.65984 6.99982L5.89151 10.2315C6.06068 10.4007 6.06068 10.6807 5.89151 10.8498C5.80984 10.9373 5.69318 10.9782 5.58234 10.9782Z",
    fill: "#514EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9581 7.4375H2.14062C1.90146 7.4375 1.70312 7.23917 1.70312 7C1.70312 6.76083 1.90146 6.5625 2.14062 6.5625H11.9581C12.1973 6.5625 12.3956 6.76083 12.3956 7C12.3956 7.23917 12.1973 7.4375 11.9581 7.4375Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.42fe7a7a0c3a627902d902dbf14704c3.svg";
export { ForwardRef as ReactComponent };